(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.customer-reviews__swiper-container');
    if (!container) return;

    const wrapper = container.querySelector('.customer-reviews__wrapper');
    const prevBtn = container.querySelector('.customer-reviews__nav-button--prev');
    const nextBtn = container.querySelector('.customer-reviews__nav-button--next');

    if (!wrapper || !prevBtn || !nextBtn) return;

    let currentIndex = 0;
    let slidesToShow = 3;
    let slideWidth = 0;

    const updateSlideWidth = function() {
      const firstSlide = wrapper.querySelector('.customer-reviews__slide');
      if (!firstSlide) return;

      if (window.innerWidth <= 749) {
        slidesToShow = 1;
      } else if (window.innerWidth <= 989) {
        slidesToShow = 2;
      } else {
        slidesToShow = 3;
      }
      slideWidth = firstSlide.offsetWidth;
    };

    const goToSlide = function(index) {
      if (slideWidth === 0) return;
      const maxIndex = Math.max(0, wrapper.children.length - slidesToShow);
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      const offset = -currentIndex * slideWidth;
      wrapper.style.transform = `translateX(${offset}px)`;
    };

    const nextSlide = function() {
      goToSlide(currentIndex + 1);
    };

    const prevSlide = function() {
      goToSlide(currentIndex - 1);
    };

    setTimeout(function() {
      updateSlideWidth();
      goToSlide(0);
    }, 100);

    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);

    window.addEventListener('resize', function() {
      updateSlideWidth();
      goToSlide(currentIndex);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
